import { ICaptureFactory, ITransportFactory, ILoggerFactory } from '../../domain/interfaces/ICaptureFactory';
import { IConsoleCapture } from '../../domain/interfaces/IConsoleCapture';
import { INetworkCapture } from '../../domain/interfaces/INetworkCapture';
import { IInteractionCapture } from '../../domain/interfaces/IInteractionCapture';
import { INavigationCapture } from '../../domain/interfaces/INavigationCapture';
import { IPerformanceCapture } from '../../domain/interfaces/IPerformanceCapture';
import { IVisibilityCapture } from '../../domain/interfaces/IVisibilityCapture';
import { ITransport } from '../../domain/interfaces/ITransport';
import { ILogger } from '../../domain/interfaces/ILogger';
import { SdkConfig } from '../../domain/types';

import { ConsoleCapture } from '../capture/ConsoleCapture';
import { NetworkCapture } from '../capture/NetworkCapture';
import { InteractionCapture } from '../capture/InteractionCapture';
import { NavigationCapture } from '../capture/NavigationCapture';
import { PerformanceCapture } from '../capture/PerformanceCapture';
import { VisibilityCapture } from '../capture/VisibilityCapture';
import { HttpTransport } from '../transport/HttpTransport';
import { ConsoleLogger } from '../logger/ConsoleLogger';

export class CaptureFactory implements ICaptureFactory {
  createConsoleCapture(): IConsoleCapture {
    return new ConsoleCapture();
  }

  createNetworkCapture(): INetworkCapture {
    return new NetworkCapture();
  }

  createInteractionCapture(): IInteractionCapture {
    return new InteractionCapture();
  }

  createNavigationCapture(): INavigationCapture {
    return new NavigationCapture();
  }

  createPerformanceCapture(): IPerformanceCapture {
    return new PerformanceCapture();
  }

  createVisibilityCapture(): IVisibilityCapture {
    return new VisibilityCapture();
  }
}

export class TransportFactory implements ITransportFactory {
  createTransport(config: SdkConfig): ITransport {
    if (!config.endpoint) {
      throw new Error('Endpoint is required for transport creation');
    }
    
    const transport = new HttpTransport({
      endpoint: config.endpoint,
      batchInterval: config.batchInterval,
      maxBatchSize: config.maxBatchSize,
      maxRetries: config.maxRetries,
      baseDelay: config.retryBaseDelay
    });

    if (config.apiKey) {
      transport.setApiKey(config.apiKey);
    }

    return transport;
  }
}

export class LoggerFactory implements ILoggerFactory {
  createLogger(): ILogger {
    return new ConsoleLogger();
  }
}